module.exports = "/img/campaigns/intent-exploring-tooltip.png?2d3233868a67b38cc62dac91fe807ed4";